module.exports = __webpack_public_path__ + "images/7bf8cb3cf7e455dd7829899dfca96fa7.svg";